<script>
import MixedGridFiltersItemRange from '@phoenix/mixins/components/mixedGrid/MixedGridFiltersItemRange';

export default {
  mixins: [MixedGridFiltersItemRange],

  props: {
    isMobile: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    rangeClasses() {
      return ['range', { 'btn--disabled': this.filter.disabled }];
    },

    containerClasses() {
      return this.isMobile ? 'container container--md pt-2 sm:pt-4 pb-5' : 'collapse__body p-4 pt-2';
    },
  },
};
</script>

<template>
  <div :class="containerClasses">
    <div class="range-slider m-12 px-4">
      <div
        :id="uniqueId"
        ref="range"
        :class="rangeClasses"
        :data-property="filter.id"
        :data-label="filter.label"
        :data-options="filter.options"
        :data-items="filter.items"
      ></div>
    </div>
  </div>
</template>
